import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box, Container } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { siteConfig } from '../config/siteConfig';
import logo from '../assets/allcoder-performance-logo.png';
import './app.css';
const Header = () => {

    return (
        <AppBar
            position="sticky"
            sx={{
                bgcolor: 'rgba(44, 62, 80, 0.95)',
                backdropFilter: 'blur(10px)',
                boxShadow: '0 2px 20px rgba(0,0,0,0.1)'
            }}
        >
            <Container maxWidth="lg">
                <Toolbar sx={{ justifyContent: 'space-between', py: 1 }}>

                    <img src={logo} alt="AllCoder-Performance" className="app-header__logo" />
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <Typography
                            variant="h5"
                            sx={{
                                fontWeight: 'bold',
                                color: 'white',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5
                            }}
                        >
                            <Box
                                component="span"
                                sx={{
                                    bgcolor: siteConfig.colors.primary,
                                    color: 'white',
                                    px: 1.5,
                                    py: 0.5,
                                    borderRadius: 1,
                                    fontSize: '1.2rem'
                                }}
                            >
                                {siteConfig.logo.text}
                            </Box>
                            <Typography
                                component="span"
                                sx={{
                                    color: 'white',
                                    ml: 1,
                                    fontSize: '0.9rem',
                                    fontWeight: 500
                                }}
                            >
                                {siteConfig.logo.subtitle}
                            </Typography>
                        </Typography>
                    </Box>

                    {/* Navigation */}
                    <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 1, alignItems: 'center' }}>
                        <Button
                            sx={{
                                bgcolor: siteConfig.colors.primary,
                                color: 'white',
                                px: 3,
                                fontWeight: 600,
                                '&:hover': {
                                    bgcolor: '#c0392b'
                                }
                            }}
                        >
                            Chiptuning
                        </Button>

                        <Button
                            endIcon={<KeyboardArrowDown />}
                            sx={{
                                color: 'white',
                                fontWeight: 500,
                                '&:hover': {
                                    bgcolor: 'rgba(255,255,255,0.1)'
                                }
                            }}
                        >
                            Leistungen
                        </Button>

                        <Button
                            sx={{
                                bgcolor: '#27ae60',
                                color: 'white',
                                px: 3,
                                fontWeight: 600,
                                ml: 1,
                                '&:hover': {
                                    bgcolor: '#229954'
                                }
                            }}
                        >
                            Dashboard
                        </Button>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Header;